import { Injectable, ElementRef } from '@angular/core';
import { WebApiService } from '@app/core/services/web-api.service';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { WidgetData } from './models/widget-data';
import { GenericActionResult } from '@app/core/models';
import { HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
//import {tylerresetpassword} from '../../core/models/tyler-resetpassword.model';
import {TylerResetPassword} from '../../core/models/state-list.model';

const routes = {
  LAwidgetData: '/courtorder/GetDashboardDataByUserID',
  OCwidgetData: '/OCDashboard/GetOCDashboardDataByUserID',
  TYwidgetData: '/TYDashboard/GetTYDashboardDataByUserID',
  TYILwidgeData:'/TYDashboard/GetTYDashboardDataByUserIDAndStateCode',

  OCDashboardDetails: '/OCDashboard/GetOCDashboardDetailByUserIdAndStatus',
  TYDashboardDetails: '/TYDashboard/GetTYDashboardDetailByUserIdAndStatus',
  TYIlTXDashboardDetails: '/TYDashboard/GetTYDashboardDetailByUserIdAndStatusForILTX',

  tylerRegistration: {
    get: '/TylerRegistration/registration',
    put: '/TylerRegistration/registration',
    post: '/TylerRegistration/registration',
    resend: '/TylerRegistration/resend-activation',
    resetPassword: '/TylerRegistration/reset-password'
    
   
  },
  tylerRegistrationForm: {
    get: '/TylerRegistration/registration-form'
  },
  UpdateRoleMapping:(isBilling: string, isAdmintool: string) => `/OCDashboard/isBilling/${isBilling}/isAdmintool/${isAdmintool}`,
  removeOCDrafts: (orderNumber: number) => `/OCDashboard/drafts/${orderNumber}`,
  removeTYDrafts: (orderNumber: number) => `/TYDashboard/drafts/${orderNumber}`,
  //OCCaseDetailByOrderNumber: (orderNumber: number) => `/OCDashboard/GetCaseDetailByOrderNumber/${orderNumber}`,
  OCCaseDetailByOrderNumber: (orderNumber: number, sType: string) => `/OCDashboard/GetCaseDetailByOrderNumber/${orderNumber}/source-type/${sType}`,
  TYCaseDetailByOrderNumber: (orderNumber: number, sType: string) => `/TYDashboard/GetCaseDetailByOrderNumber/${orderNumber}/source-type/${sType}`,
  ocDownloadFile: (orderNumber: number, filepath: string) => `/OCDashboard/downloadFile/${orderNumber}/filepath/${filepath}`
};

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  anchor: ElementRef;
  //currentOrderNumber = new BehaviorSubject<number>(0);
  currentOrderNumber = new BehaviorSubject<string>('');

  constructor(private api: WebApiService) { }

  resolver = (response) => response.data;

  getLADashboardData(): Observable<WidgetData> {
    return this.api.get(routes.LAwidgetData)
      .pipe(
        map(this.resolver)
      );
  }
  getOCDashboardData(): Observable<WidgetData> {
    return this.api.get(routes.OCwidgetData)
      .pipe(
        map(this.resolver)
      );
  }

  saveTylerRegistration(registration) {
    const loaded = false;

    if (loaded) {
      this.putTylerRegistration(registration).subscribe(response => {
        // snackbar Registration Update Successful
      });
    } else {
      this.postTylerRegistration(registration).subscribe(response => {
        // snackbar Registration Save Successful
      });
    }
  }

  getTylerRegistrationForm(): Observable<GenericActionResult> {
    return this.api.get(routes.tylerRegistrationForm.get);
  }

  getTylerRegistrationFormWithStateCode(code:string): Observable<GenericActionResult> {
    return this.api.get(routes.tylerRegistrationForm.get+'?stateCode='+code);
  }

  getTylerRegistration(): Observable<GenericActionResult> {
    return this.api.get(routes.tylerRegistration.get);
  }

  getTylerRegistrationWithStateCode(code:string): Observable<GenericActionResult> {
    return this.api.get(routes.tylerRegistration.get+'?stateCode='+code);
  }

  resendActivationEmail(): Observable<GenericActionResult> {
    return this.api.get(routes.tylerRegistration.resend);
  }

  resendActivationEmailForTylerManagement(stateCode:string): Observable<GenericActionResult> {
    return this.api.get(routes.tylerRegistration.resend+'?stateCode='+stateCode);
  }

  resetPassword(passwordAnswer: string): Observable<GenericActionResult> {
    return this.api.post(routes.tylerRegistration.resetPassword, { passwordAnswer: passwordAnswer });
  }

  resetPasswordForTylerManagement(tylerResetPwd:TylerResetPassword): Observable<GenericActionResult> {
    return this.api.post(routes.tylerRegistration.resetPassword,tylerResetPwd);
  }

  isUserRegistered(): Observable<boolean> {
    return this.getTylerRegistration()
      .pipe(map(registration => {
        if (registration.isSuccess && registration.data) {
          return (registration && registration.data && !registration.data.activationRequired);
        }
        return false;
      }));
  }

  isUserRegisteredForTylerManagement(stateCode:string): Observable<boolean> {
    return this.getTylerRegistrationWithStateCode(stateCode)
      .pipe(map(registration => {
        if (registration.isSuccess && registration.data) {
          return (registration && registration.data && !registration.data.activationRequired);
        }
        return false;
      }));
  }

  putTylerRegistration(form): Observable<GenericActionResult> {

    return this.api.put(routes.tylerRegistration.put, form);
  }

  postTylerRegistration(form): Observable<GenericActionResult> {

    return this.api.post(routes.tylerRegistration.post, form);
  }

  getTYDashboardData(): Observable<WidgetData> {
    return this.api.get(routes.TYwidgetData).pipe(map(this.resolver));
  }

  getOCCourtOrderByUserIdAndStatus(status: string): Observable<GenericActionResult> {
    return this.api.get(`${routes.OCDashboardDetails}?status=${status}`);
  }

  getTYDashboardDataByStateCode(status: string): Observable<WidgetData> {
    return this.api.get(`${routes.TYILwidgeData}?status=${status}`).pipe(map(this.resolver));
  }

  getTYCourtOrderByUserIdAndStatusForTXIL(status: string,statuscode:string): Observable<GenericActionResult> {
    return this.api.get(`${routes.TYIlTXDashboardDetails}?status=${status}&stateCode=${statuscode}`);
  }

  getTYCourtOrderByUserIdAndStatus(status: string): Observable<GenericActionResult> {
    return this.api.get(`${routes.TYDashboardDetails}?status=${status}`);
  }

  removeOCDrafts(orderNumber: number) {
    return this.api.delete(routes.removeOCDrafts(orderNumber))
  }

  removeTYDrafts(orderNumber: number) {
    return this.api.delete(routes.removeTYDrafts(orderNumber))
  }

  getOCCaseDetailByOrderNumber(orderNumber: number, sType) {
    return this.api.get(routes.OCCaseDetailByOrderNumber(orderNumber, sType));
  }
  getTYCaseDetailByOrderNumber(orderNumber: number, sType) {
    return this.api.get(routes.TYCaseDetailByOrderNumber(orderNumber, sType));
  }
  setOrderNumber(orderNumber) {
    this.currentOrderNumber.next(orderNumber);
  }

  hidePanel = () => this.setOrderNumber(0);

  setAnchor(element: ElementRef) {
    this.anchor = element;
  }
  getDownloadFile(orderNumber: number, filepath: string): Observable<GenericActionResult> {
    return this.api.get(routes.ocDownloadFile(orderNumber, filepath));
  }
  scrollToTop() {
    setTimeout(() => this.anchor.nativeElement.scrollIntoView(), 300);
  }

  private baseUrl(dashboard: string): string {
    return dashboard === 'LA' ? environment.clientUrl
      : dashboard === 'OC' ? environment.eFilingOCAppBaseUri
        : environment.eFilingTylerAppBaseUri;
  }

  // goToNewFiling(dashboard: string, caseNumber: string, courtKey: string) {
    
  //   const caseNumberUrl = `${this.baseUrl(dashboard)}/new-filing?caseNumber=${caseNumber}`;
  //   const fullUrl = courtKey ? `${caseNumberUrl}&courtKey=${courtKey}` : caseNumberUrl;
  //   window.location.href = fullUrl;
  // }

  goToSubsequentFiling(dashboard: string, caseNumber: string, courtKey: string) {
    const caseNumberUrl = `${this.baseUrl(dashboard)}/subsequent/filing/case/${caseNumber}`;
    const fullUrl = (!!courtKey && (dashboard === 'TY' || dashboard ==='TX' || dashboard==='IL'||dashboard==='MD'||dashboard==='IN')) ? `${caseNumberUrl}/${courtKey}` : caseNumberUrl;
    window.location.href = fullUrl;
  }

  continueNewFiling(dashboard: string, orderNumber: string) {    
    const orderNumberUrl = `${this.baseUrl(dashboard)}/new-filing/${orderNumber}`;
    window.location.href = orderNumberUrl;
  }

  continueSubsequentFiling(dashboard: string, orderNumber: string) {    
    const orderNumberUrl = `${this.baseUrl(dashboard)}/subsequent/filing/${orderNumber}`;
    window.location.href = orderNumberUrl;
  }
  updateRoleMaping(isBiling: string, isAdminTool: string): Observable<GenericActionResult> {
    return this.api.put(routes.UpdateRoleMapping(isBiling,isAdminTool));
  }
}
